import { css } from '@emotion/react';
import { desktopFirstMediaQuery, mobileFirstMediaQuery } from '@inflearn/ds-react';

/**
 * NOTE: js로 모바일 여부를 판단하는 것 보다 가벼움
 * 768 초과일 때 가린다.
 */
export const styleShowOnlyMobile = css({
  [mobileFirstMediaQuery.tablet]: {
    display: 'none',
  },
});

/**
 * 768 이하일 때 가린다.
 */
export const styleShowOnlyLargerThanMobile = css({
  [desktopFirstMediaQuery.mobile]: {
    display: 'none',
  },
});
